import { Box, styled } from '@mui/material';

const PREFIX = 'TSMED-SystemMonitorPreview';

const Root = styled(Box, {
  name: PREFIX,
  slot: 'Root',
})(() => ({
  display: 'flex',
  borderRadius: 'inherit',
}));

export const SystemMonitorPreview = () => (
  <Root>
    <img
      style={{ borderRadius: 'inherit', pointerEvents: 'none' }}
      src="/system-monitor.png"
      alt="System Monitor"
      width={195}
      height={145}
    />
  </Root>
);
